// import TopHeader from "../../../../components/general/TopHeader";
// import MaxDemandMisLog from "./MaxDemandMisLog/MaxDemandMisLog";

// export default function MaxDemandMis(){
//     return(
//         <>
//         <TopHeader/>
//         <MaxDemandMisLog/>
//         </>
//     )
// }

// 2.

import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
// import TopHeader from '../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { PvMonitoringContext } from '../../../../context/PvMonitoringContext';
// import PvParameterTabContent from '../pv_monitoring/pv_monitoring_tabs/pv_parameter/pv_parameter_tabs/PvParameterTabContent';
import { WEB_KEY, PASS_KEY } from '../../../../api/AxiosApi';
import TopHeader from '../../../../components/general/TopHeader';
import Loading from '../../../../components/loading/Loading';
import DataNotFound from '../../../../components/error/DataNotFound';
import MaxDemandMisLog from './MaxDemandMisLog/MaxDemandMisLog';

// import Inverter1Tabs from './tabs/Inverter1Tabs';

export default function MaxDemandMis() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    const { getPvMnMenu_INV, PvMnMenuData_INV, Pv_MnMenu_INV_Loading } = useContext(PvMonitoringContext)
    const USER_ID = localStorage.getItem('LoginID')
    const PLANT_code = localStorage.getItem('LCODE')
    const Stype = ""
    const [key, setKey] = useState('');
    const pass_key="XYZ321"

    // console.log("lcode",LOC_CODE)

    useEffect(() => {
        if (PvMnMenuData_INV && PvMnMenuData_INV?.length > 0) {
            setKey(PvMnMenuData_INV[0]?.ID);
        }
    }, [PvMnMenuData_INV]);

    useEffect(() => {
        getPvMnMenu_INV(USER_ID, PLANT_code, pass_key, Stype)
    }, [USER_ID])

    return (
        <>
            <CssBaseline />
            <TopHeader />
            <Box py={spacing(1)} bgcolor={'background.default'}>
                {
                    Pv_MnMenu_INV_Loading ? <Loading /> :
                        PvMnMenuData_INV?.length <= 0 ?
                            <DataNotFound /> :
                            <Tabs
                                style={{ justifyContent: "flex-end", }}
                                id="controlled-tab-example"
                                activeKey={key}
                                onSelect={(k) => setKey(k)}
                            >
                                {

                                    PvMnMenuData_INV?.map((item, index) => {
                                        return (
                                            <Tab key={index} eventKey={item?.ID} title={item?.NAME}>
                                                <MaxDemandMisLog TabTitle={item?.NAME} ID={key} />
                                            </Tab>
                                        )
                                    })


                                }


                            </Tabs>

                }


            </Box>
        </>

    )
}